import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
const {
  endpoints: {
    company: { delegations: url },
  },
} = config

const getUrl = (delegation) =>
  url
    .replace(':idCompany', delegation.idCompany || delegation.company)
    .replace(':idDelegation', delegation._id ? `?idDelegation=${delegation._id}` : '')

/**
 * Add a new delegation to the company
 * @param {Object} delegation
 */
const addDelegation = (delegation) => axios.post(getUrl(delegation), { delegation }, { headers: getHeaders(true) })

const getDelegations = (delegation) => axios.get(getUrl(delegation), { headers: getHeaders(true) })

const updateDelegation = (delegation) => axios.put(getUrl(delegation), { delegation }, { headers: getHeaders(true) })

const deleteDelegation = (delegation) => axios.delete(getUrl(delegation), { headers: getHeaders(true) })

export default { addDelegation, getDelegations, updateDelegation, deleteDelegation }
